/**
 * CSRF Token Utility
 * Reads the csrf_token cookie set by backend and provides it for mutating requests.
 */

const CSRF_COOKIE_NAME = 'csrf_token';

/**
 * Read CSRF token from cookie
 */
export function getCsrfToken() {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, ...valueParts] = cookie.trim().split('=');
    if (name === CSRF_COOKIE_NAME) {
      return valueParts.join('=');
    }
  }
  return null;
}

/**
 * Get headers object with CSRF token included.
 * Merges with any existing headers.
 */
export function withCsrf(headers = {}) {
  const token = getCsrfToken();
  if (token) {
    return { ...headers, 'X-CSRF-Token': token };
  }
  return headers;
}
